import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="comment" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Comment</field.Label>
        <field.Textarea class="border rounded px-2" />
      </div>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>